import type { Rotina, RotinaInput } from '@acme/core'

import ApiService from '../api.service'

/** Rotina como a API devolve: o input já normalizado mais os campos de controle. */
export type RotinaApi = Rotina & {
    id: number
    clienteId: number
    ativa: boolean
    criadoPorId: number
    atualizadoPorId: number
    createdAt: string
    updatedAt: string
}

const service = new ApiService<RotinaInput, RotinaApi, { empresaId?: number }>(
    'rotinas',
)

/** Pausa ou reativa a rotina sem reenviar a configuração inteira. */
function alternarAtiva(id: number, ativa: boolean) {
    return service.patchFrom<{ ativa: boolean }>(id, 'ativa', { ativa })
}

/** Enfileira a execução manual; avalia o último dia calculado de cada funcionário. */
function executar(id: number) {
    return service.postFrom<Record<string, never>, void>(id, 'executar', {})
}

export const rotinas = Object.assign(service, { alternarAtiva, executar })

export type StatusDisparo = 'OK' | 'FALHA' | 'IGNORADA'

export type StatusPassoDisparo = 'OK' | 'FALHA' | 'PENDENTE'

/** Um disparo (funcionário × dia) com o snapshot das condições e dos passos executados. */
export type DisparoHistorico = {
    id: number
    createdAt: string
    dia: string
    status: StatusDisparo
    motivo: string
    condicoes: { texto: string; isOk: boolean }[] | null
    acoes:
        | {
              acaoId: string
              label: string
              status: StatusPassoDisparo
              duracaoMs: number
              erro?: string
          }[]
        | null
    rotina: { id: number; nome: string }
    funcionario: { id: number; nome: string }
    retomadoDeId: number | null
    /** Algum disparo já retomou este; não pode ser reexecutado de novo. */
    isRetomado: boolean
}

export type FiltroDisparos = {
    empresaId: number
    dataInicial: string
    dataFinal: string
    /** Filtro da grade, serializado por `FilterModelPro.toUrlParams`. */
    filter?: string
    page: number
    pageSize: number
}

const disparosService = new ApiService<
    Record<string, never>,
    DisparoHistorico,
    FiltroDisparos
>('rotinas/disparos')

/** Enfileira a retomada do disparo em FALHA a partir da ação que falhou. */
function retomar(id: number) {
    return disparosService.postFrom<Record<string, never>, void>(
        id,
        'retomar',
        {},
    )
}

export const disparosRotina = Object.assign(disparosService, { retomar })
